/* eslint-disable no-mixed-operators */
/* eslint-disable no-case-declarations */
/* eslint-disable no-param-reassign */
/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import { useState, useEffect, useContext } from 'react';

import Button from '../../juristec-ui/core/Button';
import MainTabs from '../../juristec-ui/core/Tabs';
import Select from '../../juristec-ui/core/Select';
import SelectNew from '../../juristec-ui/core/SelectNew';
import Loader from '../../juristec-ui/core/Loader';
import CustomSide from '../../juristec-ui/kpis/controllers';
import SelectTips from '../Popovers/SelectTips';
import KpiModifier from './KpiModifier';
import useKpiData from '../../hooks/useKpiData';

import {
  useKpiModifiers,
  useModifierConfig,
  columnIsDate,
} from '../../hooks/modifiers';
import {
  dateOptions,
  controlVarDescription,
  drilldownVarDescription,
} from '../../options';
import { error } from '../../label';
import uuidv4 from '../../juristec-ui/utils/functions/randomUUID';
import { AlertContext } from '../../context/AlertProvider';
import { TourContext } from '../../context/TourProvider';
import { FilesContext } from '../../context/FilesProvider';
import { AuthContext } from '../../context/AuthProvider';

import {
  StyledContainerDoubleSelect,
  StyledContentTab,
  StyledContainerButtonActions,
} from './styled/KpiCreate.styled';

import {
  Gears,
} from '../../juristec-ui/icons';

const groupOrigins = {
  linesMap: 'Linha',
  columnsMap: 'Coluna',
  drilldownMap: 'Subgráfico',
};

const filterOrigins = {
  filter: 'Filtro',
};

const KpiSideBar = ({
  chartType = 'Table',
  dataFrameOptions = {
    filter: () => { },
    find: () => { },
  },
  dataFrameTypes = {},
  handleStyleConfig = () => { },
  handleDDStyleConfig = () => { },
  pivotTable = {},
  refresh = false,
  setShowGenChartAlert = () => { },
  selectedDatabase = {},
  setMetaGen = () => { },
  setPivotTable = () => { },
  styleConfig = {},
  toEditOptions = {
    meta: {},
  },
  resetStyles = () => { },
  isGlobalThemeActive = false,
  isGlobalFontActive = false,
  advancedChartsAllowed = false,
}) => {
  const { currentUser } = useContext(AuthContext);
  const { setAlertConfig } = useContext(AlertContext);
  const { filesAPI } = useContext(FilesContext);

  const [kpiDataAPI] = useKpiData(currentUser);

  const [isLoading, setIsLoading] = useState(false);

  // Line/Column state
  const [selectedLine, setSelectedLine] = useState(undefined);
  const [selectedLineMap, setSelectedLineMap] = useState(undefined);
  const [selectedColumn, setSelectedColumn] = useState(undefined);
  const [selectedColumnMap, setSelectedColumnMap] = useState(undefined);

  const [selectedDrilldown, setSelectedDrilldown] = useState(undefined);
  const [selectedDrilldownMap, setSelectedDrilldownMap] = useState(undefined);

  // Values state
  const [selectedValue, setSelectedValue] = useState(undefined);
  const [selectedMultiValues, setSelectedMultiValues] = useState([]);
  const [selectedValue2, setSelectedValue2] = useState(undefined);
  const [functionOptions, setFunctionOptions] = useState([
    { label: 'Contagem', value: 'count', id: 'count' },
    { label: 'Contagem únicos', value: 'nunique', id: 'nunique' },
    { label: 'Soma', value: 'sum', id: 'sum' },
    { label: 'Media', value: 'mean', id: 'mean' },
    { label: 'Desvio padrão', value: 'std', id: 'std' },
  ]);
  const [selectedFunction, setSelectedFunction] = useState(functionOptions[0]);

  // Control/Drilldown state
  const [selectedControl, setSelectedControl] = useState(undefined);
  const [selectedControlMap, setSelectedControlMap] = useState(undefined);

  const [activeTab, setActiveTab] = useState('tabData');
  const [generateBtnDisabled, setGenerateBtnDisabled] = useState(true);
  const [didMount, setDidMount] = useState(false);

  const getUniqueValues = async (filterVal, filterSelectorVal) => {
    const { res, msg, error: er } = await filesAPI.getUnique(
      selectedDatabase.value,
      filterVal,
      filterSelectorVal,
    );
    if (er) {
      setAlertConfig({ type: 'error', text: error.generic, child: msg });
      return [];
    }
    return res.map((val) => ({ label: val, value: val, id: val }));
  };

  const {
    modifierConfig: modifierConfigF,
    simpleOptions: simpleOptionsF,
    originOptions: originOptionsF,
    getColumnOptions: getColumnOptionsF,
    getSimpleOptions: getSimpleOptionsF,
    handleModifierConfigs: handleModifierConfigsF,
    resetModifierConfigs: resetModifierConfigsF,
    //
    configColumnIsDate: configColumnIsDateF,
    getOptionsByConfigGroup: getOptionsByConfigGroupF,
    checkModifierValues: checkModifierValuesF,
  } = useModifierConfig({
    dataFrameTypes,
    modifierOrigins: filterOrigins,
    getUniqueValues,
  });

  const {
    modifierConfig: modifierConfigG,
    simpleOptions: simpleOptionsG,
    originOptions: originOptionsG,
    getColumnOptions: getColumnOptionsG,
    getSimpleOptions: getSimpleOptionsG,
    handleModifierConfigs: handleModifierConfigsG,
    resetModifierConfigs: resetModifierConfigsG,
    //
    configColumnIsDate: configColumnIsDateG,
    getOptionsByConfigGroup: getOptionsByConfigGroupG,
    checkModifierValues: checkModifierValuesG,
  } = useModifierConfig({
    dataFrameTypes,
    modifierOrigins: groupOrigins,
    getUniqueValues,
  });

  const handleModifierChange = () => {
    setGenerateBtnDisabled(false);
  };

  function objectToArray(obj) {
    if (Array.isArray(obj)) return obj;
    if (obj?.rules) {
      return Object.keys(obj.rules).reduce((aux, name) => {
        aux.push({
          uid: uuidv4(),
          ftype: 'values',
          column: obj.target,
          values: obj.rules[name],
          selector: '',
          inverse: false,
          rule: name,
        });
        return aux;
      }, []);
    }
    return [];
  }

  const {
    modifiers,
    addModifier,
    removeModifier,
    editModifier,
    changeModifierOrder,
    resetModifiers,
  } = useKpiModifiers({
    dataFrameTypes,
    initialModifiers: {
      filter: toEditOptions?.meta?.filters.map((f) => ({ ...f, uid: f.uid || uuidv4() })) ?? [],
      linesMap: objectToArray(toEditOptions?.meta?.linesMap ?? []),
      columnsMap: objectToArray(toEditOptions?.meta?.columnsMap ?? []),
      drilldownMap: objectToArray(toEditOptions?.meta?.drilldownMap ?? []),
    },
    onModifierChange: handleModifierChange,
  });

  const handleAddGroupModifier = () => {
    addModifier(modifierConfigG);
    resetModifierConfigsG();
  };

  const handleAddFilterModifier = () => {
    addModifier(modifierConfigF);
    resetModifierConfigsF();
  };

  const { tourOpen, nextStep, refreshTour } = useContext(TourContext);
  useEffect(() => setDidMount(true), []);

  const getGroupingOptions = () => {
    const aux = {};
    if (selectedLine) aux.linesMap = [selectedLine];
    if (selectedColumn) aux.columnsMap = [selectedColumn];
    if (selectedDrilldown) aux.drilldownMap = [selectedDrilldown];
    return aux;
  };

  const getDateSelector = (origin) => {
    switch (origin) {
      case 'linesMap':
        return selectedLineMap;
      case 'columnsMap':
        return selectedColumnMap;
      case 'drilldownMap':
        return selectedDrilldownMap;
      default:
        return dateOptions[0];
    }
  };

  /**
   * Filters variable options, removing already selected variables
   * @param {string} selectType Select identifier ('value', 'line', 'column' or 'control')
   * @returns {array} Filtered options
   */
  const getVarsOptions = (selectType) => {
    if (didMount) {
      if (selectType === 'control') return dataFrameOptions;
      if (selectType === 'drilldown') {
        return dataFrameOptions.filter((opt) => (
          (selectType === 'drilldown' || opt?.value !== selectedDrilldown?.value)
          && (selectType === 'value' || opt?.value !== selectedValue?.value)
          && (selectType === 'value2' || opt?.value !== selectedValue2?.value)
          && !(selectedLine?.value?.length > 0 && selectedColumn?.value?.length > 0 && chartType === 'Line')
        ));
      }
      if (['BoxPlot', 'ScatterPlot', 'Histogram', 'Bullet', 'Gauge'].includes(chartType) && selectType.includes('value')) {
        return dataFrameOptions.filter((opt) => (
          (opt?.type === 'float64' || opt?.type === 'int64')
          && (selectType === 'value' || opt?.value !== selectedValue?.value)
          && (selectType === 'value2' || opt?.value !== selectedValue2?.value)
          && opt?.value !== selectedLine?.value && opt?.value !== selectedColumn?.value
        ));
      }
      if (selectedMultiValues?.length > 0 && !selectedValue && selectType === 'value') {
        const tableValues = selectedMultiValues.map((v) => v.value);
        const isValue = ['int64', 'float64'].includes(selectedMultiValues[0]?.type);
        return dataFrameOptions.filter((opt) => (
          (selectType === 'value' || (!tableValues.includes(opt?.value) || opt?.type === 'datetime64[ns]'))
          && (selectType === 'line' || ((opt?.value !== selectedLine?.value || opt?.type === 'datetime64[ns]') && (
            (isValue && ['int64', 'float64'].includes(opt?.type)) || (!isValue && !['int64', 'float64'].includes(opt?.type))
          )))
        ));
      }
      // if (chartType === 'BoxPlot' && selectType === 'value') {
      // eslint-disable-next-line max-len
      //   return dataFrameOptions.filter((opt) => (opt?.type === 'float64' || opt?.type === 'int64'));
      // }
      return dataFrameOptions.filter((opt) => {
        const tableValues = selectedMultiValues?.map((v) => v.value);
        return (
          (selectType === 'value' || (opt?.value !== selectedValue?.value || opt?.type === 'datetime64[ns]'))
          && (selectType === 'value2' || (opt?.value !== selectedValue2?.value || opt?.type === 'datetime64[ns]'))
          && (selectType === 'line' || ((opt?.value !== selectedLine?.value && !tableValues?.includes(opt?.value)) || opt?.type === 'datetime64[ns]'))
         && (selectType === 'column' || ((opt?.value !== selectedColumn?.value && !tableValues?.includes(opt?.value)) || opt?.type === 'datetime64[ns]'))
        );
      });
    }
    return [];
  };

  /**
   * Filters date format options, removing already selected formats
   * @param {string} selectType Select identifier ('line' or 'column')
   * @returns {array} Filtered options
   */
  const getDateFormatOptions = (selectType) => {
    if (didMount) {
      return dateOptions.filter((opt) => (
        selectedColumn?.value !== selectedLine?.value || (
          (selectType === 'line' || (!selectedLine?.value || opt?.value !== selectedLineMap?.value))
          && (selectType === 'column' || (!selectedColumn?.value || opt?.value !== selectedColumnMap?.value))
        )
      ));
    }
    return [];
  };

  useEffect(() => {
    if (toEditOptions) {
      const selectedObject = {};
      ['lines', 'columns', 'control', 'drilldown'].forEach((key) => {
        if (toEditOptions.meta[key]?.length > 0) {
          const tmpValue = toEditOptions.meta[key][0];
          selectedObject[key] = dataFrameOptions.find((opt) => opt.value === tmpValue.column);
          selectedObject[`${key}Map`] = dateOptions.find((opt) => opt.value === tmpValue.map) || {
            label: tmpValue.map,
            value: tmpValue.map,
          };
        }
      });

      const tmpValues = toEditOptions.meta?.values.reduce((aux, v) => {
        aux.columns.push(v.column);
        aux.maps.push(v.map);
        return aux;
      }, { columns: [], maps: [] });
      const selectedValues = tmpValues.columns.map((tCol) => (
        dataFrameOptions.find((opt) => tCol === opt.value)
      )).filter((v) => Boolean(v));

      const functionValue = functionOptions.find(
        (opt) => tmpValues.maps.includes(opt.value),
      );

      setSelectedLine(selectedObject.lines);
      setSelectedLineMap(selectedObject.linesMap);
      setSelectedColumn(selectedObject.columns);
      setSelectedColumnMap(selectedObject.columnsMap);
      setSelectedControl(selectedObject.control);
      setSelectedControlMap(selectedObject.controlMap);
      setSelectedDrilldown(selectedObject.drilldown);
      setSelectedDrilldownMap(selectedObject.drilldownMap);
      if (['ScatterPlot', 'Bullet', 'Gauge'].includes(toEditOptions.type)) {
        setSelectedValue(selectedValues?.[0] ?? undefined);
        setSelectedValue2(selectedValues?.[1] ?? undefined);
      } else if (selectedValues.length > 1) {
        setSelectedMultiValues(selectedValues);
        setSelectedValue(undefined);
      } else {
        setSelectedValue(selectedValues?.[0] ?? undefined);
        setSelectedValue2(selectedValues?.[1] ?? undefined);
      }
      setSelectedFunction(functionValue);
    }
  }, []);

  /**
   * @async Generate temporary kpi data based on metadata
   * @param {object} body The metadata to generate a kpi
   */
  const setKpi = async (body) => {
    setIsLoading(true);
    const response = await kpiDataAPI.genKpiData(body, selectedDatabase.value);
    if (response.error) {
      setAlertConfig({
        type: 'error',
        text: 'Algo está incorreto!',
        child: 'Os elementos selecionados não permitem a criação do KPI',
      });
      setIsLoading(false);
      return;
    }
    setMetaGen({ ...body, error: response.errorMsg?.split('|')?.[0] ?? null });
    setPivotTable({ ...response.data });
    setIsLoading(false);
  };

  async function createKpi(noColumn) {
    // TODO tratar para que todos os campos existam senao avisar atraves do modal alert
    if (!selectedValue && !selectedMultiValues.length > 0) {
      setAlertConfig({ type: 'error', text: 'Algo está incorreto!', child: 'É necessário selecionar pelo menos o valor.' });
      return;
    }
    if (selectedMultiValues?.length > 1 && !selectedLine) {
      setAlertConfig({ type: 'error', text: 'Algo está incorreto!', child: 'É necessário selecionar uma linha para utilizar tabelas com mais de um valor.' });
      return;
    }
    if (['ScatterPlot', 'Bullet', 'Gauge'].includes(chartType) && !selectedValue2) {
      setAlertConfig({ type: 'error', text: 'Algo está incorreto!', child: 'É necessário selecionar o segundo valor.' });
      return;
    }
    if (selectedLine && dataFrameTypes[selectedLine.value] === 'datetime64[ns]' && !selectedLineMap) {
      setAlertConfig({ type: 'error', text: 'Algo está incorreto!', child: 'É necessário selecionar o formato para linha do tipo data.' });
      return;
    }
    if (selectedColumn && dataFrameTypes[selectedColumn.value] === 'datetime64[ns]' && !selectedColumnMap) {
      setAlertConfig({ type: 'error', text: 'Algo está incorreto!', child: 'É necessário selecionar o formato para coluna do tipo data.' });
      return;
    }
    if (selectedControl && dataFrameTypes[selectedControl.value] === 'datetime64[ns]' && !selectedControlMap) {
      setAlertConfig({ type: 'error', text: 'Algo está incorreto!', child: 'É necessário selecionar o formato para controle do tipo data.' });
      return;
    }
    if (selectedDrilldown && dataFrameTypes[selectedDrilldown.value] === 'datetime64[ns]' && !selectedDrilldownMap) {
      setAlertConfig({ type: 'error', text: 'Algo está incorreto!', child: 'É necessário selecionar o formato para drilldown do tipo data.' });
      return;
    }
    if (selectedDrilldown && !selectedLine) {
      setAlertConfig({ type: 'error', text: 'Algo está incorreto!', child: 'É necessário selecionar uma linha para utilizar subgráficos.' });
      return;
    }

    const linesToSend = selectedLine
      ? [
        {
          column: selectedLine.value,
          map:
            (dataFrameTypes[selectedLine.value] === 'datetime64[ns]' && selectedLineMap)
              ? selectedLineMap.value
              : 'category',
          type: dataFrameTypes[selectedLine.value],
        },
      ]
      : [];

    const columnToSend = !noColumn && selectedColumn
      ? [
        {
          column: selectedColumn.value,
          map:
            (dataFrameTypes[selectedColumn.value] === 'datetime64[ns]' && selectedColumnMap)
              ? selectedColumnMap.value
              : 'category',
          type: dataFrameTypes[selectedColumn.value],
        },
      ]
      : [];

    let valuesToSend = [];

    if (selectedValue) {
      valuesToSend = [
        {
          column: selectedValue?.value,
          map: selectedFunction?.value,
          type: dataFrameTypes[selectedValue?.value],
        },
      ];
    } else if (selectedMultiValues && selectedMultiValues?.length > 0) {
      if (!noColumn) {
        valuesToSend = selectedMultiValues?.map((v) => ({
          column: v.value,
          map: selectedFunction?.value,
          type: dataFrameTypes[v.value],
        }));
      } else {
        valuesToSend = [
          {
            column: selectedMultiValues[0]?.value,
            map: selectedFunction?.value,
            type: dataFrameTypes[selectedMultiValues[0]?.value],
          },
        ];
      }
    }

    if (['ScatterPlot', 'Bullet', 'Gauge'].includes(chartType) && selectedValue2) {
      valuesToSend.push({
        column: selectedValue2?.value,
        map: selectedFunction?.value,
        type: dataFrameTypes[selectedValue2?.value],
      });
    }

    const controlToSend = selectedControl?.value ? ([{
      column: selectedControl.value,
      map: (dataFrameTypes[selectedControl.value] === 'datetime64[ns]' && selectedControlMap)
        ? selectedControlMap.value
        : 'category',
      type: dataFrameTypes[selectedControl.value],
    }]) : [];
    const drilldownToSend = selectedDrilldown?.value?.length > 0
      && !(selectedLine?.value?.length > 0
        && selectedColumn?.value?.length > 0
        && chartType === 'Line'
      ) ? ([{
        column: selectedDrilldown.value,
        map: (dataFrameTypes[selectedDrilldown.value] === 'datetime64[ns]' && selectedDrilldownMap)
          ? selectedDrilldownMap.value
          : 'category',
        type: dataFrameTypes[selectedDrilldown.value],
      }]) : [];

    const currentBody = {
      database: selectedDatabase?.value || '',
      fileOwner: selectedDatabase?.owner || '',
      lines: linesToSend,
      columns: columnToSend,
      values: valuesToSend,
      control: controlToSend,
      drilldown: drilldownToSend,
      filters: modifiers.filter,
      linesMap: modifiers.linesMap,
      columnsMap: modifiers.columnsMap,
      drilldownMap: modifiers.drilldownMap,
      ownerId: currentUser.uid,
      kpi_type: chartType,
    };

    try {
      setKpi(currentBody);
      // setMetaGen(currentBody);
    } catch (err) {
      setAlertConfig({ type: 'error', text: 'Algo está incorreto!', child: 'Os elementos selecionados não permitem a criação do KPI' });
    } finally {
      if (tourOpen) nextStep();
      setGenerateBtnDisabled(true);
    }
  }

  const resetPage = () => {
    setPivotTable(null);
    setSelectedValue('');
    setSelectedMultiValues([]);
    setSelectedValue2('');
    setSelectedLine('');
    setSelectedColumn('');
    setSelectedControl('');
    setSelectedDrilldown('');
    resetModifiers();
    resetStyles();
    setShowGenChartAlert(false);
  };

  useEffect(() => {
    if (selectedValue && !generateBtnDisabled) {
      setShowGenChartAlert(true);
    }
  }, [generateBtnDisabled]);

  useEffect(() => {
    if (!(selectedValue)) {
      setGenerateBtnDisabled(true);
    }
  }, [selectedValue]);

  useEffect(() => {
    if (didMount) { resetPage(); setGenerateBtnDisabled(false); }
  }, [refresh]);

  useEffect(() => {
    const handleFunctionByValue = (value) => {
      switch (dataFrameTypes[value]) {
        case 'category':
        case 'datetime64[ns]':
        case 'object':
          setFunctionOptions([
            { label: 'Contagem', value: 'count', id: 'count' },
            { label: 'Contagem únicos', value: 'nunique', id: 'nunique' },
          ]);
          if (!toEditOptions) {
            setSelectedFunction({ label: 'Contagem', value: 'count', id: 'count' });
          }
          break;

        case 'int64':
        case 'float64':
          setFunctionOptions([
            { label: 'Soma', value: 'sum', id: 'sum' },
            { label: 'Media', value: 'mean', id: 'mean' },
          ]);
          if (!toEditOptions) {
            setSelectedFunction({ label: 'Soma', value: 'sum', id: 'sum' });
          }
          break;

        default:
          setFunctionOptions([]);
          setSelectedFunction({});
          break;
      }
    };
    if (selectedValue?.value) {
      handleFunctionByValue(selectedValue.value);
      if (toEditOptions && toEditOptions.meta.values[0].column === selectedValue?.value) {
        setSelectedFunction(
          functionOptions.find(
            (opt) => opt.value === toEditOptions.meta.values[0].map,
          ),
        );
      }
    } else if (selectedMultiValues?.length > 0) {
      handleFunctionByValue(selectedMultiValues[0].value);
    }
  }, [selectedValue, selectedMultiValues]);

  useEffect(() => {
    if (didMount && modifiers.linesMap?.length > 0 && ((
      modifiers.linesMap[0]?.column !== selectedLine?.value
    ) || (
      columnIsDate(dataFrameTypes, selectedLine)
        && modifiers.linesMap[0]?.ftype === 'values'
        && modifiers.linesMap[0]?.selector !== selectedLineMap?.value
    ))) {
      resetModifiers(['filter', 'columnsMap', 'drilldownMap']);
      resetModifierConfigsG();
    }
  }, [selectedLine, selectedLineMap]);

  useEffect(() => {
    if (didMount && modifiers.columnsMap?.length > 0 && ((
      modifiers.columnsMap[0]?.column !== selectedColumn?.value
    ) || (
      columnIsDate(dataFrameTypes, selectedColumn)
        && modifiers.columnsMap[0]?.ftype === 'values'
        && modifiers.columnsMap[0]?.selector !== selectedColumnMap?.value
    ))) {
      resetModifiers(['filter', 'linesMap', 'drilldownMap']);
      resetModifierConfigsG();
    }
  }, [selectedColumn, selectedColumnMap]);

  useEffect(() => {
    if (didMount && modifiers.drilldownMap?.length > 0 && ((
      modifiers.drilldownMap[0]?.column !== selectedDrilldown?.value
    ) || (
      columnIsDate(dataFrameTypes, selectedDrilldown)
        && modifiers.drilldownMap[0]?.ftype === 'values'
        && modifiers.drilldownMap[0]?.selector !== selectedDrilldownMap?.value
    ))) {
      resetModifiers(['filter', 'linesMap', 'columnsMap']);
      resetModifierConfigsG();
    }
  }, [selectedDrilldown, selectedDrilldownMap]);

  useEffect(() => {
    if (toEditOptions) {
      setActiveTab('tabStyles');
    }
  }, []);

  const genChart = (noColumn = true) => {
    createKpi(noColumn);
    resetStyles();
  };

  const genChartBtn = () => {
    genChart(false);
    setShowGenChartAlert(false);
  };

  useEffect(() => {
    if (chartType === 'Calendar' && selectedLineMap?.value === 'D' && generateBtnDisabled) {
      const years = pivotTable.index.reduce((aux, d) => {
        const y = d?.match(/\d{4}/);
        if (y) aux.push(y);
        return aux;
      }, []).sort();

      if (Number(years?.[years?.length - 1])
        && Number(years?.[0])
        && years?.[years?.length - 1] - years?.[0] > 4
      ) {
        setAlertConfig({
          type: 'warning',
          text: 'Atenção!',
          child: (
            <>
              <span>
                O gráfico de Calendário possui um intervalo muito grande entre os anos informados.
              </span>
              <br />
              <span>Recomendamos utilizar a guia filtros para otimização da leitura</span>
            </>
          ),
        });
      }
    } else if (['Pie', 'Map', 'Funnel', 'Waffle', 'Pareto'].includes(chartType)
    && pivotTable?.columns.length > 1 && pivotTable?.data.length > 0) {
      setSelectedColumn('');
      const getLabel = {
        Pie: 'de pizza',
        Map: 'geográfico',
        Funnel: 'de funil',
        Waffle: 'de waffle',
        Pareto: 'de pareto',
      };
      setAlertConfig({
        type: 'warning',
        text: `O gráfico ${getLabel[chartType]} está sendo carregado com propriedades não permitidas. Para melhorar sua experiência, retiramos as colunas para este KPI!`,
        okFunction: genChart,
      });
    } else if (['BoxPlot', 'Histogram'].includes(chartType) || ['BoxPlot', 'Histogram'].includes(styleConfig?.type)) {
      if (['float64', 'int64'].includes(selectedValue?.type ?? selectedMultiValues?.[0]?.type)
        && styleConfig.type !== chartType) genChart(false);
    } else if (['ScatterPlot', 'Bullet', 'Gauge'].includes(chartType) || ['ScatterPlot', 'Bullet', 'Gauge'].includes(styleConfig?.type)) {
      if (selectedValue2?.value?.length > 0 && styleConfig.type !== chartType) genChart(false);
    } else if ((chartType === 'Line' || styleConfig?.type === 'Line') && selectedDrilldown?.value?.length > 0) {
      if (selectedColumn?.value?.length > 0 && styleConfig.type !== chartType) genChart(false);
    }
    if (![
      'Bar', 'Line', 'Pie', 'Map', 'Funnel', 'RadialBar', 'BoxPlot',
    ].includes(chartType) && selectedDrilldown?.value?.length > 0) {
      setSelectedDrilldown('');
      setGenerateBtnDisabled(false);
    }
  }, [chartType, generateBtnDisabled]);

  useEffect(() => {
    if (didMount) {
      if (![
        'Pie', 'Map', 'Funnel', 'Calendar', 'Waffle', 'ScatterPlot', 'Pareto', 'Histogram', 'Bullet', 'Gauge',
      ].includes(chartType)) {
        if (!(selectedMultiValues?.length > 0)) {
          const values = selectedValue ? [selectedValue] : [];
          setSelectedMultiValues(values.filter((v) => Boolean(v)));
        }
        setSelectedValue('');
      } else if (selectedMultiValues?.length > 0) {
        setSelectedValue(selectedMultiValues[0]);
        setSelectedMultiValues([]);
      }
    }
  }, [chartType, didMount]);

  useEffect(() => {
    if (selectedMultiValues?.length > 1) setSelectedColumn('');
  }, [selectedMultiValues]);

  if (tourOpen) refreshTour();

  return (
    <>
      {isLoading && <Loader />}
      <StyledContainerButtonActions className="gerar_grafico">
        <Button
          size="large"
          variant="outlined"
          onClick={resetPage}
          // disabled={!selectedValue && filtersToSend.length === 0}
        >
          Resetar
        </Button>
        <Button
          size="large"
          onClick={genChartBtn}
          disabled={
            (
              !selectedValue
              && !selectedMultiValues?.length > 0
            )
            || generateBtnDisabled
          }
        >
          Gerar Gráfico
          <Gears />
        </Button>
      </StyledContainerButtonActions>
      <MainTabs
        blockers={{
          hasValue: Boolean(selectedValue || selectedMultiValues?.length > 0),
          hasLine: Boolean(selectedLine),
          hasPivotTable: Boolean(pivotTable),
        }}
        check={{
          tabGroups: ['hasValue', 'hasLine', 'hasPivotTable'],
          tabStyles: ['hasValue', 'hasPivotTable'],
          tabFilters: ['hasValue', 'hasPivotTable'],
        }}
        head={[
          { text: 'Dados', id: 'tabData' },
          { text: 'Agrupamento', id: 'tabGroups' },
          { text: 'Filtros', id: 'tabFilters' },
          { text: 'Estilos', id: 'tabStyles' },
        ]}
        active={activeTab}
        setActive={setActiveTab}
      >
        <StyledContentTab className="kpi-side-content-tab">
          <div style={{
            display: 'flex',
            flexDirection: 'column',
          }}
          >
            <StyledContainerDoubleSelect>
              <Select
                isSearchable
                placeholder="Selecione"
                selectLabel="Valor*"
                onChange={(newValue) => {
                  setGenerateBtnDisabled(false);
                  if (![
                    'Pie', 'Map', 'Funnel', 'Calendar', 'Waffle', 'ScatterPlot', 'Pareto', 'Histogram', 'Bullet', 'Gauge',
                  ].includes(chartType)) {
                    setSelectedMultiValues(newValue);
                  } else {
                    setSelectedValue(newValue);
                  }
                }}
                options={getVarsOptions('value')}
                value={
                  selectedMultiValues?.length > 0
                    ? selectedMultiValues
                    : selectedValue
                    || { label: selectedValue, value: selectedValue, id: selectedValue }
                }
                isMult={![
                  'Pie', 'Map', 'Funnel', 'Calendar', 'Waffle', 'ScatterPlot', 'Pareto', 'Histogram', 'Bullet', 'Gauge',
                ].includes(chartType)}
                isClearable
                fullWidth
                alphabeticalOrder
              />
              {
                ((selectedValue && !['BoxPlot', 'ScatterPlot', 'Histogram', 'Bullet', 'Gauge'].includes(chartType))
                || (selectedMultiValues?.length > 0))
                && (
                  <SelectNew
                    searchable
                    label="Função"
                    onChange={(newValue) => {
                      setGenerateBtnDisabled(false);
                      setSelectedFunction(newValue?.label ? newValue : null);
                    }}
                    value={selectedFunction}
                    options={functionOptions}
                  />
                )
              }
            </StyledContainerDoubleSelect>
            {['ScatterPlot', 'Bullet', 'Gauge'].includes(chartType) && (
              <StyledContainerDoubleSelect>
                <SelectNew
                  searchable
                  placeholder="Selecione"
                  label="Valor Secundário*"
                  onChange={(newValue) => {
                    setGenerateBtnDisabled(false);
                    setSelectedValue2(newValue?.label ? newValue : null);
                  }}
                  options={getVarsOptions('value2')}
                  value={selectedValue2 || (
                    { label: selectedValue2, value: selectedValue2, id: selectedValue2 }
                  )}
                  clearable
                  sortBy="ascending"
                />
              </StyledContainerDoubleSelect>
            )}
            {/* <hr style={{ width: '50%' }} /> */}
            {!['Histogram'].includes(chartType) && (
              <StyledContainerDoubleSelect>
                <SelectNew
                  searchable
                  placeholder="Selecione"
                  label="Linha"
                  onChange={(newValue) => {
                    setGenerateBtnDisabled(false);
                    setSelectedLine(newValue?.label ? newValue : null);
                  }}
                  options={getVarsOptions('line')}
                  value={selectedLine || (
                    { label: selectedLine, value: selectedLine, id: selectedLine }
                  )}
                  clearable
                  sortBy="ascending"
                />
                {(selectedLine && (dataFrameTypes[selectedLine.value] === 'datetime64[ns]')) && (
                  <SelectNew
                    searchable
                    placeholder="Selecione"
                    label="Formato"
                    onChange={(newValue) => {
                      setGenerateBtnDisabled(false);
                      setSelectedLineMap(newValue?.label ? newValue : null);
                    }}
                    options={getDateFormatOptions('line')}
                    value={selectedLineMap}
                    sortBy="ascending"
                  />
                )}
              </StyledContainerDoubleSelect>
            )}

            {![
              'Pie', 'Map', 'Funnel', 'Calendar', 'Waffle', 'ScatterPlot', 'Pareto', 'Histogram', 'Bullet', 'Gauge',
            ].includes(chartType) && !(selectedMultiValues?.length > 1) && (
              <StyledContainerDoubleSelect>
                <SelectNew
                  searchable
                  placeholder="Selecione"
                  label="Coluna (opcional)"
                  onChange={(newValue) => {
                    setGenerateBtnDisabled(false);
                    setSelectedColumn(newValue?.label ? newValue : null);
                  }}
                  options={getVarsOptions('column')}
                  value={selectedColumn || (
                    { label: selectedColumn, value: selectedColumn, id: selectedColumn }
                  )}
                  clearable
                  sortBy="ascending"
                />
                {(selectedColumn && (dataFrameTypes[selectedColumn.value] === 'datetime64[ns]')) && (
                  <SelectNew
                    searchable
                    placeholder="Selecione"
                    label="Formato"
                    onChange={(newValue) => {
                      setGenerateBtnDisabled(false);
                      setSelectedColumnMap(newValue?.label ? newValue : null);
                    }}
                    value={selectedColumnMap}
                    options={getDateFormatOptions('column')}
                    formatOptionLabel={false}
                    sortBy="ascending"
                  />
                )}
              </StyledContainerDoubleSelect>
            )}
            {['Bar', 'Line', 'Pie', 'Map', 'Funnel', 'RadialBar', 'BoxPlot'].includes(chartType)
            && selectedLine?.value?.length > 0
            && !(selectedColumn?.value?.length > 0 && chartType === 'Line')
            && (
              <StyledContainerDoubleSelect>
                <div style={{ position: 'relative' }}>
                  <SelectNew
                    searchable
                    placeholder="Selecione"
                    label="Subgráfico (opcional)"
                    onChange={(newValue) => {
                      setGenerateBtnDisabled(false);
                      setSelectedDrilldown(newValue?.label ? newValue : null);
                    }}
                    options={getVarsOptions('drilldown')}
                    value={selectedDrilldown || (
                      { label: selectedDrilldown, value: selectedDrilldown, id: selectedDrilldown }
                    )}
                    clearable
                    sortBy="ascending"
                  />
                  <SelectTips
                    description={drilldownVarDescription}
                    style={{ top: '-5px', right: '2px' }}
                  />
                </div>
                {(selectedDrilldown && (dataFrameTypes[selectedDrilldown.value] === 'datetime64[ns]')) && (
                  <SelectNew
                    searchable
                    placeholder="Selecione"
                    label="Formato"
                    onChange={(newValue) => {
                      setGenerateBtnDisabled(false);
                      setSelectedDrilldownMap(newValue?.label ? newValue : null);
                    }}
                    value={selectedDrilldownMap}
                    options={dateOptions}
                    sortBy="ascending"
                  />
                )}
              </StyledContainerDoubleSelect>
            )}
            <StyledContainerDoubleSelect>
              <div style={{ position: 'relative' }}>
                <SelectNew
                  searchable
                  placeholder="Selecione"
                  label="Controle (opcional)"
                  onChange={(newValue) => {
                    setGenerateBtnDisabled(false);
                    setSelectedControl(newValue?.label ? newValue : null);
                  }}
                  options={getVarsOptions('control')}
                  value={selectedControl || (
                    { label: selectedControl, value: selectedControl, id: selectedControl }
                  )}
                  clearable
                  sortBy="ascending"
                />
                <SelectTips
                  description={controlVarDescription}
                  style={{ top: '-5px', right: '2px' }}
                />
              </div>
              {(selectedControl && (dataFrameTypes[selectedControl.value] === 'datetime64[ns]')) && (
                <SelectNew
                  searchable
                  placeholder="Selecione"
                  label="Formato"
                  onChange={(newValue) => {
                    setGenerateBtnDisabled(false);
                    setSelectedControlMap(newValue?.label ? newValue : null);
                  }}
                  value={selectedControlMap}
                  options={dateOptions}
                  sortBy="ascending"
                />
              )}
            </StyledContainerDoubleSelect>

          </div>
        </StyledContentTab>

        {/* ====================== Agrupamento ====================== */}

        <StyledContentTab className="kpi-side-content-tab">
          <KpiModifier
            modifiers={modifiers}
            modifierType="group"
            columnOptsMap={getGroupingOptions()}
            getDateSelector={getDateSelector}
            modifierConfig={modifierConfigG}
            simpleOptions={simpleOptionsG}
            originOptions={originOptionsG}
            getColumnOptions={getColumnOptionsG}
            getSimpleOptions={getSimpleOptionsG}
            handleModifierConfigs={handleModifierConfigsG}
            configColumnIsDate={configColumnIsDateG}
            getOptionsByConfigGroup={getOptionsByConfigGroupG}
            checkModifierValues={checkModifierValuesG}
            modifierOrigins={groupOrigins}
            addModifier={handleAddGroupModifier}
            removeModifier={removeModifier}
            editModifier={editModifier}
            getUniqueValues={getUniqueValues}
            changeModifierOrder={changeModifierOrder}
            dataFrameTypes={dataFrameTypes}
          />
        </StyledContentTab>

        {/* ====================== Filtros ====================== */}

        <StyledContentTab className="kpi-side-content-tab">
          <KpiModifier
            modifiers={modifiers}
            modifierType="filter"
            columnOptsMap={{
              filter: Object.entries(dataFrameTypes).map(([k, v]) => ({
                label: k, value: k, id: k, type: v,
              })),
            }}
            getDateSelector={getDateSelector}
            modifierConfig={modifierConfigF}
            simpleOptions={simpleOptionsF}
            originOptions={originOptionsF}
            getColumnOptions={getColumnOptionsF}
            getSimpleOptions={getSimpleOptionsF}
            handleModifierConfigs={handleModifierConfigsF}
            configColumnIsDate={configColumnIsDateF}
            getOptionsByConfigGroup={getOptionsByConfigGroupF}
            checkModifierValues={checkModifierValuesF}
            modifierOrigins={filterOrigins}
            addModifier={handleAddFilterModifier}
            removeModifier={removeModifier}
            editModifier={editModifier}
            getUniqueValues={getUniqueValues}
            changeModifierOrder={changeModifierOrder}
            dataFrameTypes={dataFrameTypes}
          />
        </StyledContentTab>
        <StyledContentTab className="kpi-side-content-tab">
          <CustomSide
            type={chartType}
            config={styleConfig}
            handle={handleStyleConfig}
            handleDD={handleDDStyleConfig}
            data={pivotTable}
            //
            selectedLine={selectedLine}
            selectedLineMap={selectedLineMap}
            selectedColumn={selectedColumn}
            selectedColumnMap={selectedColumnMap}
            selectedValue={selectedValue}
            selectedFunction={selectedFunction}
            selectedDrilldown={selectedDrilldown}
            //
            isGlobalThemeActive={isGlobalThemeActive}
            isGlobalFontActive={isGlobalFontActive}
            advancedChartsAllowed={advancedChartsAllowed}
          />
        </StyledContentTab>
      </MainTabs>
    </>
  );
};

KpiSideBar.propTypes = {
  chartType: PropTypes.string,
  dataFrameOptions: PropTypes.arrayOf(PropTypes.object),
  dataFrameTypes: PropTypes.objectOf(PropTypes.string),
  handleStyleConfig: PropTypes.func,
  handleDDStyleConfig: PropTypes.func,
  pivotTable: PropTypes.shape({
    index: PropTypes.arrayOf(PropTypes.string),
    columns: PropTypes.arrayOf(PropTypes.string),
    data: PropTypes.arrayOf(PropTypes.array),
  }),
  refresh: PropTypes.bool,
  setShowGenChartAlert: PropTypes.func,
  selectedDatabase: PropTypes.shape({
    value: PropTypes.string,
    owner: PropTypes.string,
  }),
  setMetaGen: PropTypes.func,
  setPivotTable: PropTypes.func,
  styleConfig: PropTypes.shape({
    type: PropTypes.string,
  }),
  toEditOptions: PropTypes.shape({
    meta: PropTypes.any,
  }),
  resetStyles: PropTypes.func,
  isGlobalThemeActive: PropTypes.bool,
  isGlobalFontActive: PropTypes.bool,
  advancedChartsAllowed: PropTypes.bool,
};

export default KpiSideBar;
